import './Footer.css';

const Footer = () => {
  return (
    <div style={{ margin: "0" }}>
      <div
        className="footer-container"
        style={{
          margin: "0",
          background: "linear-gradient(90deg,#ed1c24,#5b1687)",
          borderTop: "1px solid #fff",
        }}
      >
        <div
          className="footer-content"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {/* Left side: Privacy Policy and Terms & Conditions */}
          <div
            className="footer-links"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <a
              href={`${process.env.REACT_APP_BASENAME}/privacy-policy`}
              style={{ color: "#fff", textDecoration: "none" }}
              target='_blank' rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href={`${process.env.REACT_APP_BASENAME}/terms-and-conditions`}
              style={{ color: "#fff", textDecoration: "none" }}
              target='_blank' rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
            <a
              href={`${process.env.PUBLIC_URL}/caution-notice.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Caution Notice
            </a>
          </div>

          {/* Right side: Campa Cola, © 2024, and Icons */}
          <div
            className="footer-icons"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "35px",
              flexWrap: "wrap",
            }}
          >
            <p style={{ color: "#fff", margin: "0", fontSize: "15px" }}>
              © Campa-Cola 2024
            </p>
            <div style={{ display: "flex", gap: "20px" }}>
              <a href="https://www.facebook.com/officialcampacola/">
                <img
                  className="footer-icon"
                  style={{ width: "24px", height: "24px" }}
                  src="https://campabeveragesadmin.ril.com/uploads/Fcabook_Icon_58ef73655c.svg"
                  alt="Facebook Icon"
                />
              </a>
              <a href="https://www.instagram.com/officialcampa/">
                <img
                  className="footer-icon"
                  style={{ width: "24px", height: "24px" }}
                  src="https://campabeveragesadmin.ril.com/uploads/Instagram_Icon_863b568bef.svg"
                  alt="Instagram Icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <style>{`
          
        
         
      `}</style>
    </div>
  );
};

export default Footer;
